import { cn } from '@util/index';
import { BaseIconProps } from './types';

export type LogoVariant = 'white' | 'black' | 'default';
interface Props extends BaseIconProps {
  variant: LogoVariant;
}

// const getColors = (v: LogoVariant) => {
//   if (v === 'white') {
//     return {
//       iconColor: 'white',
//       textGearColor: 'white',
//       textFocusColor: 'white',
//     };
//   }
//   if (v === 'default') {
//     return {
//       iconColor: '#242E5F',
//       textGearColor: '#080C0F',
//       textFocusColor: '#F68645',
//     };
//   }
//   return {
//     iconColor: '#080C0F',
//     textGearColor: '#080C0F',
//     textFocusColor: '#080C0F',
//   };
// };

export function Logo({ variant, height = 26, width = 186 }: Props) {
  variant;
  // const { iconColor, textGearColor, textFocusColor } = getColors(variant);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 830.22 105"
      width={width}
      height={height}
    >
      <title>MXLocker</title>
      <path
        d="M82.26,128.15,53,211.21a1,1,0,0,0,.91,1.29H69.13a1,1,0,0,1,.91,1.29l-6.1,17.42a1,1,0,0,0,.92,1.29h38.93a1,1,0,0,0,.92-.66l9.56-28.68a1,1,0,0,1,1.85.59l-2.25,7.5a1,1,0,0,0,.92,1.25h14.34a1,1,0,0,1,.91,1.29l-6.1,17.42a1,1,0,0,0,.92,1.29h76.25a1,1,0,0,0,.66-.27l17.68-16.74a1,1,0,0,1,1.56.35l6.24,16a1,1,0,0,0,.9.62H596.81a1,1,0,0,0,.91-.64l7.1-19.51a1,1,0,0,1,1.73-.19l12.66,19.89a1,1,0,0,0,.81.45H793.81a1,1,0,0,0,.91-.64l8.54-23.72a1,1,0,0,1,.91-.64h.77a1,1,0,0,1,.83.47l2.44,4.06a1,1,0,0,0,.83.47h1.69a1,1,0,0,1,.95.73l4.63,18.54a1,1,0,0,0,.94.73h39a1,1,0,0,0,.94-1.23l-6.31-22.54a1,1,0,0,1,.93-1.23h11a1,1,0,0,0,.91-.66l19.35-57.06a1,1,0,0,0-.92-1.28H867.9a1,1,0,0,1-.91-1.31l7-18.38a1,1,0,0,0-.9-1.31H637.83a.93.93,0,0,0-.6.21L612,147.55a1,1,0,0,1-1.52-1.05l5.64-17.74a1,1,0,0,0-.92-1.26h-237a1,1,0,0,0-.92.66l-19.56,57.68a1,1,0,0,1-.91.66h-39a1,1,0,0,1-.92-1.26l11.2-35.48a1,1,0,0,0-.92-1.26H313.84a1,1,0,0,1-.92-1.27l6.15-18.46a1,1,0,0,0-.92-1.27h-71.3a1,1,0,0,0-.63.23l-18.71,15.91a1,1,0,0,1-1.53-.37l-6.24-15.17a1,1,0,0,0-.9-.6H143.79a1,1,0,0,0-.55.17l-14.86,10.22a1,1,0,0,1-1.4-.33L121.77,128a1,1,0,0,0-.85-.51H83.18a1,1,0,0,0-.92.65"
        transform="translate(-52.89 -127.5)"
      />
      <polygon fill="#fff" points="7.6 81 32.6 6 61.6 6 37.6 81 7.6 81" />
      <polygon
        fill="#fff"
        points="63.6 6 72.6 19 90.6 6 122.6 6 97.6 81 66.6 81 81.1 41.5 60.1 54.5 52.1 43.5 63.6 6"
      />
      <polygon
        fill="#fff"
        points="133.6 6 162.6 6 171.6 28 194.6 6 219.6 6 180.6 43 197.6 81 167.6 81 158.6 58 135.6 81 107.6 81 147.6 42 133.6 6"
      />
      <polygon
        fill="#b71c1c"
        points="228.6 6 259.6 6 232.6 81 202.6 81 228.6 6"
      />
      <polygon
        fill="#b71c1c"
        points="241.6 65 235.6 81 293.6 81 298.6 65 241.6 65"
      />
      <polygon
        fill="#b71c1c"
        points="426.6 6 401.6 81 491.6 81 498.6 61 437.6 61 450.6 25 509.6 25 516.6 6 426.6 6"
      />
      <polygon
        fill="#b71c1c"
        points="524.6 6 498.6 81 530.6 81 541.6 50 560.6 81 588.6 81 565.6 42 611.6 6 585.6 6 544.6 35 555.6 6 524.6 6"
      />
      <polygon
        fill="#b71c1c"
        points="624.6 6 599.6 81 629.6 81 653.6 6 624.6 6"
      />
      <polygon
        fill="#b71c1c"
        points="723.6 6 698.6 81 728.6 81 752.6 6 723.6 6"
      />
      <polygon
        fill="#b71c1c"
        points="656.6 6 652.6 19 709.6 19 714.6 6 656.6 6"
      />
      <polygon
        fill="#b71c1c"
        points="646.6 36 642.6 49 699.6 49 704.6 36 646.6 36"
      />
      <polygon
        fill="#b71c1c"
        points="636.6 68 632.6 81 689.6 81 694.6 68 636.6 68"
      />
      <polygon
        fill="#b71c1c"
        points="755.6 6 812.6 6 796.6 54 781.6 54 789.6 81 758.6 81 750.6 54 740.6 54 744.6 40 770.6 40 776.6 19 751.6 19 755.6 6"
      />
      <path
        fill="#b71c1c"
        d="M380.49,133.5l-25,75h90l25-75ZM422,188H392l13-37h30Z"
        transform="translate(-52.89 -127.5)"
      />
    </svg>
  );
}
export function LogoNew({ height = 20, width = 158 }: BaseIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 158 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>MXLocker</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.2574 0.0465756V3.11087C86.4811 3.11087 85.6742 3.11087 84.8417 3.11087C84.2697 3.11087 83.6824 3.11087 83.0695 3.11087H82.6763C82.5504 3.10325 82.4242 3.10325 82.2984 3.11087C82.1196 3.11087 81.9306 3.11087 81.7366 3.11087C81.0322 3.10006 80.3283 3.14962 79.6324 3.25898C79.1849 3.30918 78.7522 3.44993 78.3607 3.67266C78.0967 3.82099 77.8873 4.05013 77.7632 4.32638C77.6573 4.72081 77.6091 5.12851 77.6202 5.53677V8.4121H86.3841V11.3283H77.6202V18.8256H74.0452V5.54699C73.9932 4.49381 74.1928 3.4434 74.6274 2.48269C74.9826 1.7724 75.5502 1.19044 76.2515 0.817761C77.0209 0.433978 77.8563 0.199998 78.7131 0.128292C79.658 0.0465775 80.6743 0.0057174 81.7774 0.0057174H82.3392C82.4651 -0.0019058 82.5913 -0.0019058 82.7171 0.0057174H83.1104C83.6926 0.0057174 84.285 0.0057174 84.8826 0.0057174L87.2574 0.0465756Z"
        fill="#EF9021"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.263 3.26893C103.987 2.44315 103.471 1.71799 102.782 1.18521C102.041 0.683968 101.193 0.36224 100.305 0.245496C99.1383 0.098472 97.9627 0.0302174 96.7865 0.0412046C95.5391 0.0242523 94.2923 0.107943 93.0583 0.291458C92.1763 0.399346 91.3363 0.72975 90.6171 1.25161C89.9749 1.79943 89.5182 2.53271 89.3097 3.35065C89.0131 4.49226 88.879 5.66999 88.9113 6.84905V11.8694C88.877 13.1188 89.0179 14.3669 89.3301 15.5772C89.5524 16.419 90.0242 17.1739 90.6835 17.7426C91.3999 18.277 92.2363 18.6277 93.1196 18.764C94.3331 18.9471 95.5594 19.0308 96.7865 19.0143C97.9991 19.0282 99.2105 18.9376 100.408 18.7436C101.306 18.5928 102.156 18.2285 102.884 17.6813C103.563 17.126 104.058 16.3782 104.304 15.5363C104.627 14.3487 104.773 13.12 104.738 11.8898V6.86948C104.782 5.65122 104.621 4.43429 104.263 3.26893ZM101.158 6.84394V11.8643C101.175 12.5851 101.105 13.3053 100.949 14.0093C100.82 14.4929 100.552 14.928 100.178 15.2605C99.7844 15.5611 99.3164 15.7483 98.8243 15.8019C98.1475 15.895 97.4645 15.936 96.7814 15.9245C96.0497 15.9322 95.3182 15.8981 94.5905 15.8223C94.1146 15.7814 93.6606 15.6041 93.283 15.3116C92.9627 14.9681 92.7451 14.5417 92.6548 14.0808C92.5291 13.3524 92.4744 12.6135 92.4914 11.8745V6.85416C92.4896 6.24098 92.5443 5.62893 92.6548 5.0258C92.7096 4.59108 92.9072 4.18686 93.2166 3.87669C93.5814 3.5572 94.0296 3.34817 94.5087 3.27404C95.2571 3.12832 96.0192 3.06496 96.7814 3.08507C97.4644 3.07788 98.1471 3.11884 98.8243 3.20765C99.3062 3.24789 99.7709 3.40571 100.178 3.66729C100.547 3.94644 100.823 4.33109 100.969 4.77044C101.14 5.44923 101.204 6.15056 101.158 6.84905V6.84394Z"
        fill="#EF9021"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.484 2.30084C121.9 3.28293 122.112 4.3394 122.107 5.40599V6.42742H118.532V5.40599C118.549 4.96888 118.492 4.53205 118.364 4.11388C118.235 3.81628 117.998 3.5789 117.7 3.44995C117.32 3.26899 116.909 3.16155 116.49 3.13331C115.979 3.09245 115.33 3.07202 114.554 3.07202C113.822 3.05911 113.09 3.11554 112.368 3.24055C111.883 3.31501 111.428 3.51978 111.05 3.83299C110.729 4.20241 110.527 4.65963 110.468 5.14553C110.357 5.86865 110.308 6.59989 110.32 7.33139V11.4529C110.309 12.2125 110.351 12.972 110.448 13.7255C110.51 14.2127 110.704 14.6737 111.01 15.0585C111.358 15.4168 111.81 15.6577 112.302 15.748C113.044 15.8711 113.796 15.9258 114.549 15.9114C115.259 15.9114 115.882 15.9114 116.423 15.8501C116.872 15.826 117.311 15.7132 117.715 15.5182C118.062 15.3493 118.336 15.0609 118.486 14.7061C118.66 14.2041 118.738 13.674 118.716 13.1433V12.1219H122.291V13.3119C122.381 14.4131 122.206 15.5198 121.781 16.5396C121.446 17.234 120.891 17.798 120.202 18.1432C119.429 18.5295 118.584 18.7487 117.72 18.7867C116.777 18.8446 115.722 18.9008 114.554 18.9553C113.215 19.0467 111.87 18.9556 110.555 18.6846C109.672 18.4901 108.863 18.0492 108.221 17.4129C107.616 16.7558 107.211 15.9386 107.057 15.0585C106.844 13.9115 106.74 12.7471 106.745 11.5805V7.31096C106.711 6.08044 106.859 4.8516 107.184 3.66445C107.424 2.7916 107.908 2.00511 108.579 1.39687C109.275 0.827427 110.108 0.447467 110.994 0.293729C112.174 0.079854 113.371 -0.017654 114.569 0.00261772C115.734 0.00261772 116.769 0.0298578 117.674 0.0843341C118.485 0.113521 119.28 0.311839 120.008 0.66655C120.66 1.04244 121.177 1.61434 121.484 2.30084Z"
        fill="#EF9021"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M136.67 0.171457H140.276V13.4194C140.328 14.4747 140.121 15.5268 139.673 16.4837C139.327 17.1928 138.763 17.7726 138.064 18.1384C137.302 18.5384 136.466 18.7782 135.608 18.8432C134.653 18.9249 133.611 18.9709 132.482 18.9709C131.353 18.9709 130.357 18.9249 129.418 18.8432C128.561 18.7783 127.727 18.5384 126.966 18.1384C126.262 17.7655 125.692 17.1815 125.337 16.4684C124.888 15.5118 124.683 14.4592 124.74 13.4041V0.156128H128.315V13.4041C128.303 13.811 128.353 14.2174 128.463 14.6094C128.576 14.9249 128.797 15.1907 129.086 15.3601C129.476 15.5874 129.909 15.7301 130.357 15.7789C131.053 15.8739 131.755 15.9149 132.457 15.9015C133.139 15.908 133.821 15.8739 134.499 15.7994C134.952 15.7689 135.393 15.6399 135.792 15.4214C136.093 15.2387 136.326 14.9625 136.455 14.6349C136.594 14.2399 136.658 13.8225 136.644 13.4041L136.67 0.171457Z"
        fill="#EF9021"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M153.206 0.11747C153.966 0.151188 154.711 0.342495 155.392 0.679253C156.047 1.00376 156.581 1.53012 156.914 2.18076C157.337 3.0778 157.53 4.06589 157.476 5.05609V5.63831H153.901V5.05609C153.919 4.65118 153.857 4.24672 153.717 3.86612C153.616 3.60119 153.424 3.38055 153.176 3.24305C152.86 3.07676 152.511 2.98422 152.154 2.97237C151.736 2.97237 151.215 2.97237 150.592 2.97237C149.688 2.97237 148.968 2.99791 148.426 3.05409C147.988 3.07944 147.562 3.19967 147.175 3.40647C147.036 3.47592 146.913 3.57285 146.813 3.69137C146.713 3.8099 146.638 3.94755 146.593 4.09594C146.485 4.48999 146.437 4.89799 146.45 5.30634C146.437 5.76071 146.479 6.21496 146.572 6.65974C146.606 6.81236 146.674 6.95526 146.771 7.07745C146.869 7.19963 146.993 7.29784 147.134 7.36452C147.518 7.56061 147.936 7.68194 148.365 7.72203C148.901 7.7731 149.642 7.82927 150.571 7.88545C152.001 7.97398 153.193 8.07782 154.146 8.19699C154.908 8.3041 155.642 8.55358 156.312 8.93242C156.871 9.2871 157.284 9.83082 157.476 10.4646C157.73 11.3731 157.842 12.3154 157.808 13.2582C157.851 14.3108 157.697 15.3622 157.353 16.3582C157.085 17.0591 156.602 17.6577 155.975 18.0691C155.276 18.4984 154.484 18.7541 153.666 18.8148C152.628 18.9193 151.584 18.9687 150.541 18.9629C149.519 18.9629 148.498 18.9629 147.563 18.9016C146.701 18.8759 145.851 18.6852 145.061 18.3398C144.341 18.0196 143.738 17.4844 143.334 16.8077C142.865 15.8573 142.65 14.8015 142.711 13.7434V12.87H146.286V13.7434C146.269 14.1687 146.333 14.5935 146.475 14.9946C146.624 15.307 146.887 15.5502 147.211 15.6739C147.611 15.8495 148.041 15.9483 148.477 15.965C149.036 15.9956 149.73 16.0109 150.561 16.0109C151.208 16.0196 151.855 15.9838 152.497 15.9037C152.899 15.8564 153.281 15.6991 153.6 15.4492C153.87 15.2389 154.063 14.944 154.146 14.6116C154.222 14.1662 154.256 13.7149 154.248 13.2633C154.276 12.7638 154.19 12.2644 153.998 11.8026C153.828 11.4767 153.536 11.2308 153.186 11.1183C152.759 10.9614 152.308 10.8818 151.853 10.8834C151.342 10.8834 150.75 10.8476 150.04 10.8016C149.019 10.7506 148.084 10.6842 147.211 10.6127C146.403 10.5509 145.616 10.3268 144.897 9.95385C144.236 9.6059 143.7 9.05935 143.365 8.39106C142.955 7.40392 142.77 6.33802 142.824 5.27059C142.778 4.23971 142.97 3.21208 143.385 2.26758C143.743 1.59115 144.304 1.04436 144.989 0.70479C145.761 0.341678 146.598 0.136776 147.451 0.102149C148.396 0.0306492 149.427 0 150.551 0C151.46 0.0153215 152.348 0.04597 153.206 0.11747Z"
        fill="#EF9021"
      />
      <path
        d="M16.7879 18.2933C15.7471 18.877 14.6297 19.312 13.4682 19.5854C12.3138 19.8607 11.1311 19.9995 9.94428 19.9991C8.60266 20.0166 7.26992 19.7792 6.01688 19.2994C4.87412 18.8581 3.83196 18.1911 2.95258 17.3383C2.06656 16.4814 1.37056 15.4478 0.90972 14.3046C0.413114 13.061 0.166666 11.7316 0.184497 10.3926C0.166382 9.04015 0.425366 7.69836 0.945474 6.44983C1.42877 5.30675 2.14747 4.27831 3.05473 3.4315C3.96166 2.58653 5.02285 1.92416 6.18031 1.48057C7.40672 1.00728 8.71148 0.76989 10.026 0.780883C11.2049 0.778031 12.3768 0.960718 13.4989 1.32224C14.6292 1.69634 15.6537 2.33551 16.4866 3.18636L14.8574 4.88704C14.2255 4.2156 13.4529 3.69237 12.5949 3.35489C11.7319 2.99735 10.8069 2.8134 9.87278 2.81354C8.87079 2.80402 7.87718 2.99683 6.95148 3.38043C6.07574 3.74501 5.28209 4.28164 4.61752 4.95854C3.95103 5.64784 3.42998 6.46415 3.08537 7.3589C2.70618 8.33551 2.51723 9.37562 2.5287 10.4232C2.52108 11.4555 2.71 12.4799 3.08537 13.4415C3.43173 14.3399 3.95245 15.1609 4.61752 15.8572C5.29135 16.5493 6.10422 17.0906 7.00256 17.4455C7.97728 17.8329 9.01801 18.0272 10.0669 18.0175C10.8493 18.0127 11.6288 17.9202 12.3906 17.7418C13.1624 17.5782 13.9094 17.3137 14.6122 16.9553V11.3374H10.4039V9.32005H16.7828L16.7879 18.2933Z"
        fill="#242E5F"
      />
      <path
        d="M22.6035 0.780518H34.0997V2.82338H24.7741V8.55872H33.4818V10.5709H24.7741V17.0826H34.5645V19.0948H22.6035V0.780518Z"
        fill="#242E5F"
      />
      <path
        d="M43.8674 0.780518H45.9102L53.6885 19.0693H51.1349L49.2759 14.5749H40.1289L38.2444 19.0693H35.793L43.8674 0.780518ZM44.848 3.56903H44.7969L40.9818 12.5781H48.4485L44.848 3.56903Z"
        fill="#242E5F"
      />
      <path
        d="M56.1064 0.780528H60.7794C61.6569 0.779664 62.5335 0.832535 63.4045 0.938849C64.2154 1.02476 65.0052 1.25115 65.7385 1.60789C66.4278 1.95583 67.0088 2.48565 67.4187 3.14003C67.8815 3.9604 68.0995 4.89619 68.0469 5.83661C68.0719 6.43258 67.9773 7.02753 67.7685 7.58631C67.5597 8.14508 67.2411 8.65634 66.8314 9.08988C65.9132 9.9673 64.7328 10.5198 63.4709 10.6629L68.6649 19.0846H66.004L61.045 10.8723H58.2565V19.0846H56.0859L56.1064 0.780528ZM58.2769 8.83962H60.2125C60.8152 8.83962 61.4382 8.83962 62.0868 8.78855C62.6941 8.76259 63.2944 8.64907 63.8692 8.45148C64.3873 8.27855 64.8506 7.97202 65.2124 7.56283C65.5902 7.06444 65.7719 6.44476 65.7231 5.82129C65.7498 5.26938 65.6168 4.72149 65.3401 4.24318C65.0839 3.85444 64.7322 3.53792 64.3187 3.32389C63.8723 3.10457 63.3924 2.9613 62.8989 2.9C62.3721 2.83276 61.8416 2.79865 61.3106 2.79785H58.2463L58.2769 8.83962Z"
        fill="#242E5F"
      />
    </svg>
  );
}

export default function MinimalLogo({ className }: { className?: string }) {
  return (
    <>
      <svg
        width="180"
        height="36"
        viewBox="0 0 180 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(className, 'hidden sm:flex')}
      >
        <title>MXLocker logo</title>
        <path
          d="M0.638818 8.58731C1.20253 4.45339 4.45339 1.20253 8.58731 0.638818C14.8335 -0.212939 21.1665 -0.212939 27.4127 0.638818C31.5466 1.20253 34.7975 4.45339 35.3612 8.58731C36.2129 14.8335 36.2129 21.1665 35.3612 27.4127C34.7975 31.5466 31.5466 34.7975 27.4127 35.3612C21.1665 36.2129 14.8335 36.2129 8.58731 35.3612C4.45339 34.7975 1.20253 31.5466 0.638818 27.4127C-0.212939 21.1665 -0.212939 14.8335 0.638818 8.58731Z"
          fill="#C41719"
        />
        <g clipPath="url(#clip0_18624_138670)">
          <path
            d="M8.58629 9.5459L5.14307 21.7096H8.1081L11.4554 9.5459H8.58629Z"
            fill="white"
          />
          <path
            d="M16.2691 9.5459L12.9217 13.2492L11.7418 9.5459L10.4673 13.8877L11.4554 18.2295L15.0256 13.8877L16.2691 9.5459Z"
            fill="white"
          />
          <path
            d="M16.0137 21.7096L19.4328 9.5459H16.4563L13.0493 21.7096H16.0137Z"
            fill="white"
          />
          <path
            d="M22.5883 21.7134H25.9477L24.4236 15.2487L29.1153 9.5459H26.2944L23.7841 12.6507L23.0665 9.5459H19.7312L21.1544 15.6277L12.105 26.4539H14.9735L21.7875 18.3732L22.5883 21.7134Z"
            fill="white"
          />
          <path
            d="M19.2531 22.4082H18.7514L17.9741 25.2097H19.7916L19.8869 24.7906L18.5838 24.7785L19.2531 22.4082Z"
            fill="white"
          />
          <path
            d="M22.0826 22.4082H21.0228L20.4487 22.8394L19.9229 24.7747L20.2734 25.2338H21.2933L21.9029 24.7511L22.4287 22.8553L22.0826 22.4082ZM21.4609 24.5508L21.2336 24.746H20.596L20.4563 24.5743L20.8824 23.0416L21.1098 22.8699H21.7194L21.8788 23.0416L21.4609 24.5508Z"
            fill="white"
          />
          <path
            d="M23.6844 24.1641L23.5809 24.5909L23.3618 24.7467H22.7801L22.6487 24.5387L23.0589 23.0785L23.306 22.8712H23.9016L23.9994 23.0703L23.9232 23.4054H24.4255L24.5653 22.8152L24.2344 22.4082H23.238L22.6087 22.8871L22.0867 24.7225L22.469 25.2332H23.4457L24.035 24.7626L24.1823 24.1718L23.6844 24.1641Z"
            fill="white"
          />
          <path
            d="M26.9004 22.4082H26.3625L25.0911 23.5371L25.394 22.4082H24.8841L24.0947 25.2332H24.625L24.9 24.2557L25.3737 23.8366L25.6449 25.2332H26.1434L25.7808 23.4378L26.9004 22.4082Z"
            fill="white"
          />
          <path
            d="M27.1594 23.9485H28.0954L28.1869 23.565H27.2508L27.4299 22.875H28.7889L28.9121 22.4082H27.099L26.2944 25.2332H28.1272L28.2548 24.7626H26.932L27.1594 23.9485Z"
            fill="white"
          />
          <path
            d="M30.658 23.5937L30.8574 22.7993L30.5628 22.4082H29.1161L28.3115 25.2338H28.8088L29.1314 24.0446H29.4698L29.661 25.2338H30.1671L29.9601 24.0446H30.0998L30.658 23.5937ZM29.259 23.614L29.454 22.8795H30.1913L30.303 23.0111L30.2116 23.4461L30.0084 23.6337L29.259 23.614Z"
            fill="white"
          />
        </g>
        <g clipPath="url(#clip1_18624_138670)">
          <path
            d="M48.8474 17.0042C48.8474 14.9638 49.8488 13.5244 51.5526 13.5244C53.1879 13.5244 53.9557 14.5953 53.9557 16.4359V26.6084H59.3973V17.0042C59.3973 14.9638 60.366 13.5244 62.101 13.5244C63.7378 13.5244 64.5056 14.5953 64.5056 16.4359V26.6084H69.9442V15.4649C69.9442 11.6167 68.0083 8.97363 64.135 8.97363C61.9312 8.97363 60.095 9.91032 58.7603 11.9851H58.6934C57.8243 10.1445 56.1236 8.97363 53.8856 8.97363C51.4156 8.97363 49.7803 10.1445 48.7119 11.918H48.6075V9.47476H43.4058V26.6084H48.8474V17.0042Z"
            fill="black"
          />
          <path
            d="M88.7389 26.6102L82.9313 17.5399L88.0054 9.47656H82.2959L79.8928 13.8931H79.8258L77.2888 9.47656H71.0794L76.454 17.6086L70.5125 26.6102H76.454L79.5579 21.4896H79.6249L82.4298 26.6102H88.7389Z"
            fill="black"
          />
          <path
            d="M94.9812 2.68262H89.4727V26.6104H94.9812V2.68262Z"
            fill="black"
          />
          <path
            d="M105.164 27.1443C110.671 27.1443 114.278 23.2289 114.278 18.0756C114.278 12.9222 110.671 9.00684 105.164 9.00684C99.6878 9.00684 96.0154 12.9222 96.0154 18.0756C96.0154 23.2289 99.6909 27.1443 105.164 27.1443ZM105.129 12.8551C107.5 12.8551 108.769 14.9642 108.769 18.0756C108.769 21.1869 107.5 23.2633 105.129 23.2633C102.759 23.2633 101.524 21.1885 101.524 18.0756C101.524 14.9626 102.759 12.8551 105.129 12.8551Z"
            fill="black"
          />
          <path
            d="M123.59 27.1445C128.432 27.1445 131.57 24.0659 131.702 20.1193H126.494C126.261 22.0598 125.226 23.0636 123.523 23.0636C121.187 23.0636 120.018 21.1231 120.018 18.0773C120.018 14.966 121.187 13.0254 123.523 13.0254C125.058 13.0254 125.994 14.0293 126.326 15.5686H131.568C131.067 11.7203 128.095 9.01172 123.456 9.01172C118.047 9.01172 114.508 12.9271 114.508 18.0804C114.508 23.2338 118.081 27.1445 123.59 27.1445Z"
            fill="black"
          />
          <path
            d="M143.719 26.6104H150.028L143.319 15.9009L149.327 9.47675H143.051L137.977 15.2655V2.68262H132.602V26.6104H137.977V21.3556L139.612 19.6164L143.719 26.6104Z"
            fill="black"
          />
          <path
            d="M157.471 27.1115C159.641 27.1115 161.377 26.5432 162.813 25.5394C164.314 24.5012 165.316 23.0291 165.683 21.4898H160.377C159.91 22.5607 158.976 23.1961 157.54 23.1961C155.303 23.1961 154.034 21.7567 153.699 19.4494H165.985C166.018 15.9696 165.017 12.9909 162.981 11.1175C161.511 9.77801 159.575 8.97559 157.138 8.97559C151.93 8.97559 148.359 12.891 148.359 18.01C148.359 23.1961 151.83 27.1115 157.471 27.1115ZM157.237 12.855C159.007 12.855 160.276 14.1602 160.475 16.2022H153.733C154.101 14.1602 155.169 12.855 157.239 12.855H157.237Z"
            fill="black"
          />
          <path
            d="M176.966 9.20801C174.898 9.20801 173.495 10.1119 172.294 12.1523H172.194V9.47496H166.985V26.6086H172.422V18.9137C172.422 15.1997 174.559 13.5589 177.898 14.0288H178.03V9.34539C177.801 9.23455 177.468 9.20801 176.966 9.20801Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_18624_138670">
            <rect
              width="25.7143"
              height="16.908"
              fill="white"
              transform="translate(5.14307 9.5459)"
            />
          </clipPath>
          <clipPath id="clip1_18624_138670">
            <rect
              width="135.771"
              height="30.8571"
              fill="white"
              transform="translate(43.4058 2.57129)"
            />
          </clipPath>
        </defs>
      </svg>

      <svg
        width="132"
        height="30"
        viewBox="0 0 132 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(className, 'flex sm:hidden')}
      >
        <title>MXLocker</title>
        <path
          d="M5.29046 14.0321C5.29046 12.0484 6.26406 10.649 7.92055 10.649C9.51041 10.649 10.2569 11.6902 10.2569 13.4796V23.3695H15.5473V14.0321C15.5473 12.0484 16.4892 10.649 18.1759 10.649C19.7673 10.649 20.5138 11.6902 20.5138 13.4796V23.3695H25.8012V12.5356C25.8012 8.79422 23.9191 6.22461 20.1534 6.22461C18.0109 6.22461 16.2257 7.13528 14.9281 9.15242H14.8629C14.018 7.36295 12.3646 6.22461 10.1888 6.22461C7.7873 6.22461 6.19744 7.36295 5.15873 9.08715H5.05728V6.71181H0V23.3695H5.29046V14.0321Z"
          fill="black"
        />
        <path
          d="M44.0756 23.3718L38.4293 14.5535L43.3625 6.71411H37.8116L35.4752 11.0079H35.4101L32.9436 6.71411H26.9066L32.132 14.6203L26.3555 23.3718H32.132L35.1497 18.3935H35.2148L37.9418 23.3718H44.0756Z"
          fill="black"
        />
        <path
          d="M50.1446 0.108398H44.7891V23.3715H50.1446V0.108398Z"
          fill="black"
        />
        <path
          d="M60.0426 23.8907C65.3966 23.8907 68.9034 20.0841 68.9034 15.0739C68.9034 10.0637 65.3966 6.25708 60.0426 6.25708C54.7188 6.25708 51.1484 10.0637 51.1484 15.0739C51.1484 20.0841 54.7218 23.8907 60.0426 23.8907ZM60.0093 9.99843C62.3138 9.99843 63.5479 12.049 63.5479 15.0739C63.5479 18.0989 62.3138 20.1175 60.0093 20.1175C57.7047 20.1175 56.504 18.1004 56.504 15.0739C56.504 12.0474 57.7047 9.99843 60.0093 9.99843Z"
          fill="black"
        />
        <path
          d="M77.9579 23.8908C82.6655 23.8908 85.7165 20.8977 85.8452 17.0608H80.7818C80.5547 18.9474 79.5493 19.9233 77.8928 19.9233C75.6216 19.9233 74.486 18.0367 74.486 15.0755C74.486 12.0506 75.6216 10.164 77.8928 10.164C79.3858 10.164 80.2958 11.1399 80.6183 12.6364H85.715C85.2274 8.89508 82.3384 6.26172 77.8277 6.26172C72.5691 6.26172 69.1289 10.0683 69.1289 15.0785C69.1289 20.0887 72.6024 23.8908 77.9579 23.8908Z"
          fill="black"
        />
        <path
          d="M97.5268 23.3715H103.661L97.1377 12.9595L102.979 6.71381H96.8772L91.9441 12.3418V0.108398H86.7188V23.3715H91.9441V18.2626L93.534 16.5718L97.5268 23.3715Z"
          fill="black"
        />
        <path
          d="M110.898 23.8587C113.008 23.8587 114.696 23.3062 116.092 22.3303C117.552 21.3209 118.525 19.8897 118.883 18.3931H113.724C113.27 19.4343 112.361 20.0521 110.965 20.0521C108.791 20.0521 107.557 18.6527 107.231 16.4094H119.176C119.208 13.0262 118.234 10.1303 116.255 8.30896C114.826 7.0067 112.944 6.22656 110.574 6.22656C105.511 6.22656 102.039 10.0332 102.039 15.01C102.039 20.0521 105.414 23.8587 110.898 23.8587ZM110.671 9.99826C112.391 9.99826 113.625 11.2671 113.819 13.2524H107.264C107.622 11.2671 108.66 9.99826 110.673 9.99826H110.671Z"
          fill="black"
        />
        <path
          d="M129.853 6.45215C127.842 6.45215 126.478 7.33094 125.31 9.31469H125.213V6.71168H120.148V23.3694H125.434V15.8882C125.434 12.2774 127.512 10.6822 130.758 11.1391H130.887V6.58571C130.664 6.47795 130.34 6.45215 129.853 6.45215Z"
          fill="black"
        />
      </svg>
    </>
  );
}
